export default __webpack_public_path__ + "static/media/home-group.817e5e8b.svg";